module.exports = __webpack_public_path__ + "static/undraw_hacker_mind_6y85-2f9d0d24cc71ece6ac0176ffed0ef10e.svg";